import {TOUR_CONSTS} from "../constants";

export const initialState = {
    isShowStepList: false,
    isShowProfilePopup: false,
    activeStep: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case TOUR_CONSTS.SWITCH_OPEN_STEPS_LIST:
            return {
                ...state,
                isShowStepList: action.payload,
            };
        case TOUR_CONSTS.SWITCH_OPEN_PROFILE_POPUP:
            return {
                ...state,
                isShowProfilePopup: action.payload,
            };
        case TOUR_CONSTS.UPDATE_ACTIVE_STEP:
            return {
                ...state,
                activeStep: action.payload,
            };
        default:
            return state;
    }
}
